import React, { useState } from "react";
import Hidden from "@material-ui/core/Hidden";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Grid from "@material-ui/core/Grid";
import { Avatar, MenuList, MenuItem } from "@material-ui/core";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

// Custom
import { DropDown, StyledNavLink } from "../general";
import { logout } from "../../redux/actions/authActions";
import Colors from "../../constants/Colors";
import FirstLetterCaps from "../../util/FirstLetterCaps";

const ProfileDropDown = ({
  logout,
  theme = "light",
  user,
  inBurgerMenu = false,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = React.useRef(null);
  let history = useHistory();

  const handleLogout = () => {
    logout();
    history.push("/");
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <DropDown
      open={open}
      handleClose={handleClose}
      handleToggle={handleToggle}
      anchorRef={anchorRef}
      icon={
        <DropDownIcon
          open={open}
          theme={theme}
          user={user}
          inBurgerMenu={inBurgerMenu}
        />
      }
    >
      <MenuList>
        <MenuItem style={{ padding: 0 }} onClick={handleClose}>
          <StyledNavLink
            exact
            to="/adminpage/organisations"
            style={{ padding: "10px 20px" }}
          >
            My organisations
          </StyledNavLink>
        </MenuItem>
        <MenuItem style={{ padding: 0 }} onClick={handleClose}>
          <div onClick={handleLogout} style={{ padding: "10px 20px" }}>
            <div style={{ color: "red", fontWeight: 500 }}>Log out</div>
          </div>
        </MenuItem>
      </MenuList>
    </DropDown>
  );
};

const DropDownIcon = ({ open, theme, user, inBurgerMenu }) => {
  let style = {};
  if (inBurgerMenu) {
    style = { margin: "8px 0", paddingRight: 16 };
  }
  if (theme === "dark" && inBurgerMenu === false) {
    style = { borderLeft: "solid rgba(0,0,0,0.2) 1px", paddingLeft: 18 };
  }

  let profileText =
    FirstLetterCaps(user.firstName) +
    " " +
    FirstLetterCaps(user.lastName).charAt(0) +
    ".";

  return (
    <Grid container alignItems="center" style={style}>
      <Grid item>
        <Avatar style={{ width: 32, height: 32 }} />
      </Grid>
      <Grid
        item
        style={{
          paddingTop: 2,
          marginLeft: 12,
          marginRight: 8,
        }}
      >
        <Hidden xsDown implementation="css">
          <p
            style={{
              color: theme === "light" ? "white" : Colors.grey,
              fontSize: 16,
              fontWeight: 500,
              margin: 0,
            }}
          >
            {user ? profileText : "..."}
          </p>
        </Hidden>
      </Grid>
      <Grid item>
        <ArrowForwardIosIcon
          style={{
            transform: open ? "rotate(90deg)" : null,
            fontSize: 15,
            marginTop: 7,
            color: theme === "light" ? "white" : Colors.grey,
          }}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, { logout })(ProfileDropDown);
